var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrainingMaterialIcon = function SvgTrainingMaterialIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "24px",
    viewBox: "0 0 41 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V1---internal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-14",
    transform: "translate(-310.000000, -1193.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 1142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(310.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6734491,32.9774669 C26.2365384,30.4538931 27.0797256,28.0338888 28.2030109,25.7174541 C29.3262961,23.4010193 30.4783958,21.70635 31.65931,20.6334461 L25.2763136,15.7129906 L18.3665242,26.1330394 L8.92224758,33.3288398 L14.3458834,39.2826745 C15.9256258,37.6178695 17.5517039,36.3200132 19.2241178,35.3891056 C20.8965316,34.458198 23.0463087,33.6543184 25.6734491,32.9774669 Z",
    id: "Rectangle-14-Copy-2",
    fill: "#6D8190",
    transform: "translate(20.290779, 27.497833) rotate(47.000000) translate(-20.290779, -27.497833) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5785611,24.3293874 L34.434315,6.14357548 C34.5358692,5.93502809 34.449134,5.68364114 34.2405866,5.58208701 C34.1051896,5.51615413 33.9448552,5.52775938 33.8203644,5.61250335 L17.2443549,16.8962012 C16.8178586,17.1865277 16.4639498,17.5711718 16.2100635,18.0203159 L6.90093226,34.4888747 C6.78678728,34.6908058 6.85795201,34.9470361 7.05988313,35.0611811 C7.18704431,35.1330611 7.34241908,35.1337102 7.47017641,35.0628952 L24.1866177,25.7970895 C24.7903441,25.4624482 25.276355,24.9499854 25.5785611,24.3293874 Z",
    id: "Rectangle-14-Copy",
    fill: "#B2BBC2",
    transform: "translate(20.661645, 20.327623) rotate(47.000000) translate(-20.661645, -20.327623) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.90299395,33.7240623 C4.34170617,29.7897878 4.34170617,25.52373 3.90299395,20.925889 C6.07262514,21.7003602 8.44600176,21.9785813 11.0231238,21.7605525 C13.6002459,21.5425236 16.1597697,21.0788216 18.7016953,20.3694467",
    id: "Path-28",
    stroke: "#E9DDDC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.51343121,33.3692743 L3.81325371,33.3678289 C4.02683723,33.3675914 4.20658653,33.5276855 4.23097389,33.7398723 L4.67821217,37.6311531 C4.70469772,37.8615956 4.53935791,38.069877 4.30891536,38.0963625 C4.29315019,38.0981745 4.277295,38.0990915 4.26142605,38.0991091 L2.1713445,38.1014333 C1.93938505,38.1016912 1.75113566,37.91386 1.75087772,37.6819006 C1.75086386,37.6694363 1.75140486,37.6569775 1.75249912,37.6445613 L2.0955199,33.7524018 C2.11461356,33.5357514 2.2959412,33.3695161 2.51343121,33.3692743 Z",
    id: "Rectangle-16",
    fill: "#B2BBC2",
    transform: "translate(3.215938, 35.734631) rotate(21.000000) translate(-3.215938, -35.734631) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-11",
    fill: "#6D8190",
    cx: 19.1205264,
    cy: 20.0912255,
    rx: 1,
    ry: 1
  })))))));
};
export default SvgTrainingMaterialIcon;